import React from "react";

const SelectOptions = ({
                         label,
                         htmlFor,
                         isRequired,
                         defaultValue,
                         isError,
                         errorMsg,
                         options,
                         onChange,
                         value,
                         disabled,
                       }) => {
  const renderOptions = () => {
    if (options) {
      return options.map((item, index) => {
        return (
            <option key={index} value={index}>
              {item.name}
            </option>
        );
      });
    } else {
      return null;
    }
  };
  return (
      <>
        <label htmlFor={htmlFor}>
          {label}
          {isRequired ? <span> *</span> : null}
        </label>
        <select
            required={isRequired}
            name={htmlFor}
            id={htmlFor}
            disabled={!options || !options.length || disabled}
            value={value}
            onChange={onChange}>
          <option key="-1" value={-1} defaultValue>
            {isError ? errorMsg : defaultValue}
          </option>
          {renderOptions()}
        </select>
      </>
  );
};
export default SelectOptions;